import { render, staticRenderFns } from "./FooterReplyTo.vue?vue&type=template&id=4899e486&"
import script from "./FooterReplyTo.vue?vue&type=script&lang=js&"
export * from "./FooterReplyTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports